import { type } from "arktype";

// R-RPT-01: facts and signals only.
export const Report = type({
  id: "string",
  clientId: "string",
  period: { from: "string", to: "string", label: "string" },
  // The window the markers were compared against; absent when there was nothing to compare with.
  "previousPeriod?": { from: "string", to: "string", label: "string" },
  goals: type({ verbatim: "string", progress: "string", "measured?": { current: "number", target: "number", unit: "string" } }).array(),
  milestones: type({ text: "string", reachedAt: "string" }).array(),
  markers: type({ label: "string", current: "string", "previous?": "string | null", comparable: "boolean" }).array(),
  sessions: { completed: "number", planned: "number", "note?": "string" },
  "series?": type({ label: "string", unit: "string", points: type({ label: "string", value: "number", "goal?": "boolean" }).array() }).array(),
  coachNote: "string",
  status: "'draft' | 'held' | 'approved' | 'sent' | 'failed'",
  "autoSend?": "boolean",
  "delivery?": type({ channelId: "string", status: "'queued' | 'sent' | 'delivered' | 'read' | 'bounced' | 'failed' | 'opted_out'", at: "string" }).array(),
  createdAt: "string",
  "approvedAt?": "string | null",
});
export type Report = typeof Report.infer;
